import { render, staticRenderFns } from "./dash-right-comment-item.vue?vue&type=template&id=68751808&scoped=true"
import script from "./dash-right-comment-item.vue?vue&type=script&lang=js"
export * from "./dash-right-comment-item.vue?vue&type=script&lang=js"
import style0 from "./dash-right-comment-item.vue?vue&type=style&index=0&id=68751808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68751808",
  null
  
)

export default component.exports